<ui-dialog
    formDialog
    [form]="renameForm"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    size="small"
    [open]="isTemplateRenameModalOpen"
    header="{{ 'applicant-tracker.renameTemplate' | translate }}"
    (primaryButtonPressed)="onSaveRename(renameForm)"
    (secondaryButtonPressed)="closeTemplateRenameModal()"
    (closing)="closeTemplateRenameModal()"
>
    <form #renameForm="ngForm" autocomplete="off">
        <div class="app-grid">
            <mat-form-field class="column-12">
                <mat-label>{{ 'applicant-tracker.templateName' | translate }}</mat-label>
                <input
                    name="templateName"
                    placeholder="{{ 'applicant-tracker.templateName' | translate }}"
                    [(ngModel)]="funnelTemplate.name"
                    #templateName="ngModel"
                    required
                    matInput
                    type="text"
                />
                <mat-error *ngIf="templateName.invalid">{{ templateName.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </form>
</ui-dialog>

<ui-dialog
    formDialog
    [form]="columnAddForm"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    size="small"
    [open]="isOpenAddFunnel"
    header="{{ 'applicant-tracker.addFunnelStage' | translate }}"
    (closing)="closeAddFunnelModal()"
    (primaryButtonPressed)="onColumnAdded(columnAddForm)"
    (secondaryButtonPressed)="closeAddFunnelModal()"
    #addColumnModal
>
    <form #columnAddForm="ngForm" autocomplete="off" class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.columnName' | translate }}</mat-label>
            <input type="text" required matInput #column="ngModel" name="column" [(ngModel)]="temporaryColumnName" />
            <mat-error *ngIf="column.invalid">{{ column.errors | formErrors }}</mat-error>
        </mat-form-field>
    </form>
</ui-dialog>

<div class="ui basic segment scroll" [class.loading]="isLoading">
    <app-header
        [back]="true"
        [backRoute]="'/recruiting/templates/funnelTemplates'"
        [title]="funnelTemplate.name"
        [contextMenu]="true"
        contextMenuType="material"
    >
        <div class="buttons">
            <ui-button class="apply-button" type="outline" (click)="onAddColumn()"
                ><mat-icon svgIcon="plus"></mat-icon>{{ 'applicant-tracker.addStage' | translate }}</ui-button
            >
            <ui-button type="primary" (click)="onSaveAllChanges()">{{
                'applicant-tracker.saveTemplate' | translate
            }}</ui-button>
        </div>
        <button mat-menu-item (click)="openRenameModel()">
            {{ 'applicant-tracker.renameTemplate' | translate }}
        </button>
    </app-header>

    <app-kanban
        *ngIf="kanban"
        [isEmailAutomationForFunnelTemplateStage]="true"
        [columns]="kanban"
        [allowColumnCreation]="true"
        [allowColumnDeletion]="true"
        [allowColumnRename]="true"
        (columnOrderChanged)="funnelTemplateService.updateFunnelTemplateColumnOrder($event)"
        (columnNameUpdated)="onColumnNameUpdate($event)"
        (columnDeleted)="onColumnDeleted($event)"
    >
    </app-kanban>
</div>
